import { createSlice } from '@reduxjs/toolkit'
import { createAsyncAction } from '../utils'
import { getGlobalState, signParams, isIPhone, getPersonalToken } from '@/utils'
import { getUserInfoByCode, getUserInfoByOpenid, getKzToken } from '@/api'
import { isPersonal } from '@/utils'

// import { Toast } from 'antd-mobile'
import { getTeamInfoByPersonToken } from '@/api/my'

const initialState = {
  ...getGlobalState(),
  logged: true,
  menuList: [],
  accountInfo: {}, // 当前团队子账号信息
  user: {}, // 当前团队个人账号信息
  isPersonal: isPersonal(),
  personalAccountInfo: {}, // 个人版账号信息
  // token: '', // kz token
  experienceTimes: 0, // 体验次数,
  enterpriseList: [],
  codeList: {}
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserItem(state, action) {
      Object.assign(state, action.payload)
    },
    updateIsPersonal(state, action) {
      return {
        ...state,
        isPersonal: action.payload
      }
    },
    // 清楚账号信息
    clearAccountInfo(state, action) {
      return {
        ...state,
        accountInfo: {}, // 账号信息
        user: {} // 用户信息
      }
    }
  }
})

export const { setUserItem, updateIsPersonal, clearAccountInfo } =
  userSlice.actions

export default userSlice.reducer

export const setUserInfo = createAsyncAction(payload => {
  return async dispatch => {
    let api = getUserInfoByCode
    if (!payload.code) {
      api = getUserInfoByOpenid
    }
    let result = null
    try {
      result = await api(payload)
    } catch (error) {
      console.log('获取用户信息报错。。')
      console.log(`error ---`)
      console.log(error)
      let content = error?.data?.error_message ?? '获取用户信息出错！'
      window.localStorage['openid'] = ''
      if (!!payload.code) {
        // code那种，不刷新
        if (!isIPhone() && content.includes('code been used')) {
          // 安卓
          content = '请点击右下角授权'
        }
        // Toast.show({
        //   icon: 'fail',
        //   content
        // })
      } else {
        // Toast.show({
        //   icon: 'fail',
        //   content
        // })
        window.location.reload()
      }
    }

    console.log('store: code或openid 拿到用户信息')
    // console.log(result)

    // 本地存储openid
    window.localStorage['openid'] = result.openid
    // 拿kz token
    const param = signParams({
      openid: result.openid,
      // user_id: 29327 // H5视频解构器 需要写死的传参
      user_id: 29949 // 2022-10-24 19:00 要求改的，但是报错，先注释
    })
    let resGetKzToken = null
    try {
      resGetKzToken = await getKzToken(param)
      console.log(`openid获取kz token成功`)
      // console.log(resGetKzToken)
    } catch (error) {
      console.error('获取kz token出错')
      console.error(error)
    }
    window.localStorage['token'] = resGetKzToken || ''

    dispatch(
      setUserItem({
        logged: true,
        accountInfo: result || {},
        // token: resGetKzToken,
        experienceTimes: result.video_num
      })
    )
    return true
  }
})

export const loginAsync = createAsyncAction(payload => {
  return async dispatch => {
    dispatch(
      setUserItem({
        logged: true
      })
    )
    return true
  }
})

export const logoutAsync = () => {
  return async dispatch => {
    dispatch(
      setUserItem({
        logged: false
      })
    )
    // localStorage.clear()
    return true
  }
}

export const setExperienceTimes = createAsyncAction(payload => {
  return async dispatch => {
    dispatch(
      setUserItem({
        experienceTimes: payload > 0 ? payload : 0
      })
    )
    return true
  }
})
// 获取企业列表
export const getEnterpriseList = createAsyncAction(payload => {
  return async dispatch => {
    try {
      const res =
        (await getTeamInfoByPersonToken({
          userToken: getPersonalToken(),
          scene: 'mobile' //场景值：mobile：移动端，pc：电脑端
        })) || []
      // console.log(res)
      dispatch(
        setUserItem({
          enterpriseList: res
        })
      )
      return res
    } catch (error) {
      return []
    }
  }
})
